import { colors } from '@sweep-io/sweep-design';

export const CONNECT_STEPS_TAGS_COLORS = {
  metadataElement: colors.blue[100],
  thirdPartyIntegration: colors.storm[200],
};
